<template>
  <span :id="model?.system?.id">
    <SmartLinkItemComponent
      class="management-list"
      :id="model?.system?.id"
      :component="!model?.system?.workflow"
    >
      <SmartLinkStandaloneElement :codename="type.elements.management.codename">
        <div
          class="people-modal__grid full-list"
          v-if="props.model.elements.showAsManattVenturesTeam?.value[0]?.codename != 'yes'"
        >
          <PeopleCard
            class="people-card"
            v-for="item in people"
            :key="item.system.id"
            :item="
              {
                alias: item.elements.peopleAlias?.value,
                displayName: item.elements.displayName?.value,
                email: item.elements.email?.value,
                peopleImageUrl: item.elements.peopleImage?.value[0]?.url,
                location: item.elements?.peopleLocation.value,
                phone: item.elements.peoplePhoneNumber?.value,
                position: [item.elements.peopleTitle.value[0]?.name],
                id: item.system.id,
                vCardUrl: item.elements.vcard.value[0]?.url,
                cardAddressDisplayName: item.elements?.cardAddressDisplayName?.value
              } as SearchResultPeopleItem
            "
          />
        </div>
        <div v-else>
          <div class="row mb-4">
            <PeopleCard
              class="col-lg-6 people-card main-cards"
              v-for="(item, index) in people.slice(0, 1 + 1)"
              :key="item.system.id"
              :item="
                {
                  alias: item.elements.peopleAlias?.value,
                  displayName: item.elements.displayName?.value,
                  email: item.elements.email?.value,
                  peopleImageUrl: item.elements.peopleImage?.value[0]?.url,
                  location: item.elements?.peopleLocation.value,
                  phone: item.elements.peoplePhoneNumber?.value,
                  position: [item.elements.peopleTitle.value[0]?.name],
                  id: item.system.id,
                  showAsManattVentureTeam: true,
                  urlSlug: item.elements.urlSlug.value,
                  positionTitle: item.elements.positionTitle?.value,
                  subTitle: item.elements.subTitle?.value,
                  content: item.elements.content?.value,
                  vCardUrl: item.elements.vcard.value[0]?.url,
                  cardAddressDisplayName: item.elements?.cardAddressDisplayName?.value
                } as SearchResultPeopleItem
              "
            />
          </div>
          <div class="row gy-4">
            <PeopleCard
              class="col-lg-3 people-card"
              v-for="(item, index) in people.slice(2, people.length + 1)"
              :key="item.system.id"
              :item="
                {
                  alias: item.elements.peopleAlias?.value,
                  displayName: item.elements.displayName?.value,
                  email: item.elements.email?.value,
                  peopleImageUrl: item.elements.peopleImage?.value[0]?.url,
                  location: item.elements?.peopleLocation.value,
                  phone: item.elements.peoplePhoneNumber?.value,
                  position: [item.elements.peopleTitle.value[0]?.name],
                  id: item.system.id,
                  showAsManattVentureTeam: true,
                  urlSlug: item.elements.urlSlug.value,
                  positionTitle: item.elements.positionTitle?.value,
                  subTitle: item.elements.subTitle?.value,
                  content: item.elements.content?.value,
                  vCardUrl: item.elements.vcard.value[0]?.url,
                  cardAddressDisplayName: item.elements?.cardAddressDisplayName?.value
                } as SearchResultPeopleItem
              "
            />
          </div>
        </div>
      </SmartLinkStandaloneElement>
    </SmartLinkItemComponent>
  </span>
</template>
<script lang="ts" setup>
import { contentTypes } from '~/models'
import type { LocationPageModel, ManagementListModel, PeoplePageModel } from '~/models'
import type { SearchResultPeopleItem } from '~/types/SearchResultItem'

const type = contentTypes._management_list
const siteStore = useSiteStore()
const pageStore = usePageStore()
const props = defineProps<{ model: ManagementListModel }>()
const people = props.model.elements.management.value.map(
  (x) => pageStore.getLinkedItem<PeoplePageModel>(x) ?? siteStore.getLinkedItem<PeoplePageModel>(x)
)

//TODO
const downloadVCard = () => {}

function getPersonLocation(person: PeoplePageModel): LocationPageModel[] {
  const result = pageStore.getListAs<LocationPageModel>(person.elements.peopleLocation.value)
  if (result.length > 0) return result
  return siteStore.getListAs<LocationPageModel>(person.elements.peopleLocation.value)
}
</script>
